import { writable } from "svelte/store";
export const activePage = writable("login");
